import type { PropsWithChildren } from 'react';

import classNames from 'classnames'

import styles from './DialogHeader.module.scss';

const DialogHeader = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={classNames(styles.container, 'header')}
    >
      {children}
    </div>
  );
};

export {
  DialogHeader,
}
